import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { useSendToLenders } from "./ConditionsDialog";

export default function SendToStep() {
  const { lenders, selectedLenderIndices, toggleLender } = useSendToLenders();
  const [isExpanded, setIsExpanded] = useState(false);

  const selectedLenders = selectedLenderIndices
    .map((index) => lenders[index])
    .filter((l) => l !== undefined);
  const selectedLenderCount = selectedLenders.length;

  return (
    <div>
      <div className="flex flex-row gap-2 text-[14px] font-semibold mb-2">
        <span className="text-[#1453F5] bg-[#E1E8FF] rounded-full w-6 h-6 flex items-center justify-center">
          1
        </span>
        <p className="text-[#697083] flex items-center justify-center">
          SEND TO
        </p>
      </div>

      {/* Default View - Collapsed */}
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        disabled={true}
        className="w-full flex items-center justify-between p-3 bg-gray-50 border border-gray-200 rounded-lg hover:bg-gray-100 transition-colors ease-200 text-left disabled:cursor-not-allowed"
      >
        <div className="flex flex-col">
          <p className="text-sm font-medium text-gray-900">
            {selectedLenderCount} lender{selectedLenderCount !== 1 ? "s" : ""}{" "}
            selected
          </p>
          <p className="text-xs text-gray-500">
            {selectedLenders.map((l) => l.name || "Unknown").join(", ")}
          </p>
        </div>
        <ChevronDown
          size={20}
          className={`text-gray-600 transition-transform ease-200 ${
            isExpanded ? "rotate-180" : ""
          }`}
        />
      </button>

      {/* Expanded View - Full List */}
      {isExpanded && (
        <div className="mt-3 border border-gray-200 rounded-lg bg-white p-4">
          <div className="space-y-3">
            {lenders.map((lender, index) => (
              <label
                key={`${lender.id}-${index}`}
                className="flex items-center cursor-pointer hover:bg-gray-50 p-2 rounded transition-colors ease-200"
              >
                <input
                  type="checkbox"
                  checked={selectedLenderIndices.includes(index)}
                  onChange={() => toggleLender(index)}
                  className="w-4 h-4 rounded border-gray-300 text-blue-600 cursor-pointer"
                />
                <span className="ml-3 text-sm font-medium text-gray-900">
                  {lender.name || `Lender ${index + 1}`}
                </span>
              </label>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
